const initialState = {
  destinationName: null,
  domainCulture: null,
  popularApartments: null,
  serviceId: null,
};

export const landing = (state = initialState) => state;
